import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { WelcomePopupComponent } from './pages/login-signup/welcome-popup/welcome-popup.component';
import { BookingsModule } from './modules/bookings/bookings/bookings.module';
import { QueryParamChecker } from './services/interceptor.service';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      "title": "Home"
    },
    canActivate: [QueryParamChecker]
  },
  {
    path: 'hotels',
    loadChildren: () => import('./pages/hotels/hotels-pages.module').then(m => m.HotelsPagesModule),
    canActivate: []
  },
  {
    path: 'user',
    loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule),
    canActivate: []
  },

  {
    path: 'checkout/:id',
    loadChildren: () => import('./pages/checkout/checkout.module').then(m => m.CheckoutModule),
    canActivate: []
  },
  {
    path: 'mytrips',
    loadChildren: () => import('./pages/find-booking/find-booking.module').then(m => m.FindBookingModule),
  },
  {
    path: 'policies',
    loadChildren: () => import('./pages/policies/policies.module').then(m => m.PolicyModule)
  },
  {
    path: 'content',
    loadChildren: () => import('./pages/static-content/static-content.module').then(m => m.StaticContentModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login-signup/login-signup.module').then(m => m.LoginSignupModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/login-signup/login-signup.module').then(m => m.LoginSignupModule)
  },
  {
    path: 'update-password',
    loadChildren: ()=> import('../app/pages/login-signup/login-signup.module').then(m => m.LoginSignupModule)
  },
  {
    path: 'onboard',
    component: WelcomePopupComponent,
    loadChildren: () => import('./pages/login-signup/login-signup.module').then(m => m.LoginSignupModule)
  },
  {
    path: 'mytrips-details',
    loadChildren: () => import('./modules/bookings/bookings/bookings.module').then(m => m.BookingsModule)
  },
  {
    path: 'blogs',
    loadChildren: () => import('./pages/blogs/blogs.module').then(m => m.BlogsModule)
  },
  // {
  //   path: '',
  //   loadChildren: () => import('./modules/header-menu/header-menu.module').then(m => m.HeaderMenuModule)
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }


